import clsx from "clsx";
import { type ChangeEvent, type ComponentProps, useCallback } from "react";

import { Heading } from "@shared/ui/typography";

import s from "./steps.module.scss";

type LastStepProps = ComponentProps<"div"> & {
  className?: string;
  step: string;
  question: string;
  answer?: string | string[];
  disabled: boolean;
  onChangeAnswer: (step: string, answer: string | string[]) => void;
};

export const LastStep = (props: LastStepProps) => {
  const { className, step, question, answer, disabled, onChangeAnswer } = props;

  const handleInputChange = useCallback(
    ({ target }: ChangeEvent<HTMLInputElement>) => {
      onChangeAnswer(step, target.value);
    },
    [onChangeAnswer, step],
  );

  return (
    <div className={clsx(s.root, className)}>
      <Heading level={4} className={s.title}>
        {question}
      </Heading>
      <div className={clsx(s.inputWrap, { [s.disabled]: disabled })}>
        <input
          type="text"
          placeholder="Напишите свой вариант"
          className={s.input}
          value={Array.isArray(answer) ? "" : (answer ?? "")}
          onChange={handleInputChange}
        />
      </div>
    </div>
  );
};

LastStep.displayName = "LastStep";
